import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import View from '@play-co/timestep-core/lib/ui/View';
import { ImageScaleView } from '@play-co/timestep-core/ui';
import sounds from 'src/lib/sounds';
import { Feature } from 'src/replicant/analytics';
import PopupBasicLazy from 'src/game/components/popups/PopupBasicLazy';
import { AssetGroup } from '@play-co/timestep-core';
import { downscale } from 'src/conf/scale';
import { animateRewards } from 'src/game/minigame/match2-timestep/rewards/match2-rewards.utils';
import { guestLineLoginReward } from 'src/replicant/guest/guest.ruleset';

const ui = uiConfig.buruburu.invite.confirm;
type CloseHandler = (accepted: boolean) => void;

export default class PopupLineGuestLoginReward extends PopupBasicLazy {
  constructor(opts: { superview: View; close: CloseHandler }) {
    super({
      superview: opts.superview,
      close: () => opts.close(false),
      ...ui.popup,
      width: 600,
      height: 600,
      tracking: {
        feature: Feature.NATIVE._,
        $subFeature: Feature.NATIVE.GUEST_LOGIN_REWARDS,
      },
    });

    this.message.updateOpts({
      ...ui.message,
      centerOnOrigin: true,
      width: 450,
      height: 100,
      x: this.box.style.width / 2,
      y: 410,
    });

    new ImageScaleView({
      superview: this.box,
      width: downscale(477),
      height: downscale(452),
      centerOnOrigin: true,
      x: this.box.style.width / 2,
      y: 220,
      image: `assets/ui/guest/line_login_reward.png`,
    });

    new ButtonScaleViewWithText({
      superview: this.box,
      ...ui.okButton,
      centerOnOrigin: true,
      x: this.box.style.width / 2,
      y: 510,
      localeText: () => i18n('basic.ok'),
      onClick: async () => {
        sounds.sfx.play('ok');

        // Animate the rewards
        await animateRewards(this.box, [guestLineLoginReward], {
          x: this.box.style.width / 2 - 25,
          y: this.box.style.height / 2 + 30,
          r: 0,
          width: 80,
          height: 80,
          scale: 1,
          anchorX: 0,
          anchorY: 0,
        });

        return opts.close(true);
      },
      tracking: {
        feature: Feature.NATIVE._,
        $subFeature: Feature.NATIVE.GUEST_LOGIN_REWARDS_OK,
      },
    });
  }

  protected getAssetsGroup(): AssetGroup {
    return new AssetGroup(['assets/ui/guest/line_login_reward.png']);
  }

  public init() {
    super.init({
      title: i18n('native.guest.lineLoginReward.title'),
      message: i18n('native.guest.lineLoginReward.message'),
    });
  }
}
